import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DS_DEMO_DNA2_9 = {
  title:
    "With AI innovations in Infosys Data \nStreams, it accelerates the data \ntransformation process and enables her \nto apply it at scale, delivering projects on \nbudget and on time compared to the \nclient's previous experiences.",
  subtitle: "Data STREAMS demo",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(214),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(212),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA2/DNA2_DS_DEMO_09_computer.png",
          imageStyle: {
            position: "absolute",
            right: "73.59px",
            bottom: "255.58px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_09_screen.png",
          imageStyle: {
            position: "absolute",
            right: "170px",
            bottom: "339px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_09_bubble.png",
          imageStyle: {
            position: "absolute",
            right: "493px",
            bottom: "157px",
          },
        },
      ]}
      pageNumber={213}
    />
  ),
};
